<template>
    <div ref="barGraphVehicleType"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
    data(){
        return {
            chart : null
        }
    },
    props : ['datas'],
    mounted(){
        this.createChart();
        this.loadData();
    },
    methods : {
        createChart(){
            this.chart = am4core.create(this.$refs.barGraphVehicleType, am4charts.XYChart);
            this.chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let title = this.chart.titles.create();
            title.text = "Replaced QR By Vehicle Type";
            title.fontSize = 25;
            title.marginBottom = 30;
    
            var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "type";
            categoryAxis.title.text = "Vehicle Type"
    
            var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Number of Vehicles";
            valueAxis.title.rotation = 270;
            valueAxis.title.align = "center";
            this.xAxis = true;
            valueAxis.maxPrecision = 0;
            valueAxis.min = 0;
    
            // Create series
            var series = this.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "count";
            // series.name = "Average";
    
            series.dataFields.categoryX = "type";
    
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = .8;
    
            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        },
        loadData(){
            let length = this.chart.data.length;

            for(var i = 0 ; i < this.datas.length ; i++){
                if(this.datas[i].type == null){
                    this.datas[i].type = "Unknown";
                    break;
                }
                    
            }

            this.chart.addData(this.datas, length);
        }
    }
}
</script>